import { NgModule } from '@angular/core';
import { ConsumerBulkInteractionModel } from './consumer-bulk-interaction.model';

export class BulkCreditInteractionModel extends ConsumerBulkInteractionModel{
    value: number;
}
